import { render, staticRenderFns } from "./subject-based-tool.vue?vue&type=template&id=74dac09a&scoped=true"
import script from "./subject-based-tool.ts?vue&type=script&lang=ts&external"
export * from "./subject-based-tool.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-based-tool.scss?vue&type=style&index=0&id=74dac09a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dac09a",
  null
  
)

export default component.exports